<template>
  <div class="split_button_container">
    <slot>
      <a class="main_split_button_action " aria-label="Edit" href="#">
        {{ LANG.action }}
      </a>
    </slot>
    <i-dropdown class="split_button_dropdown">
      <template v-slot:trigger="{toggle, attrs}">
        <a class="split_button_trigger" @click.prevent="toggle" v-bind="attrs">
          <i aria-hidden="true" :title="LANG.moreOptionsLabel" class="fa5 fas fa-sort-down" name="sort-down"></i>
          <span class="sr-only">{{ LANG.moreOptionsLabel }}</span>
        </a>
      </template>
      <template v-slot:default="{...props}">
        <slot name="dropdown" v-bind="props"></slot>
      </template>
    </i-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '../icon/Icon.vue';
import Dropdown from '../dropdown/Dropdown.vue';

export default {
  name: 'i-split-button',
  components: {
    [Icon.name]: Icon,
    [Dropdown.name]: Dropdown,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['LANG']),
  },
  methods: {},
};
</script>

<style scoped lang='scss'>
  /* FIXME: support focus ring */
  a.split_button_trigger {
    outline: 0;
  }
</style>
